'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pxto = /*#__PURE__*/require('../internalHelpers/_pxto');

var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/(0, _pxto2.default)('em');
exports.default = em;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/helpers/em.js
// module id = 144
// module chunks = 22676092666560 221374088121123